
import BaseApi from './BaseApi';
import LoginDTO from '../models/LoginDTO';
import LoginResponseDTO from '../models/LoginResponseDTO';
import GenericResponseDTO from '../models/GenericResponseDTO';

export class LoginApiService extends BaseApi {

    // post: api/login/VerifyPassword
    public verifyPassword(dto: LoginDTO): Promise<LoginResponseDTO> {
        let url = `api/login/VerifyPassword`;

        url = url.replace(/null|undefined/gi, '');
        return this.SendRequest<any, LoginResponseDTO>(dto, 'post', url, true, false);
    }

    // NOTE: Dev Login API moved to DevLoginApiController (9/25/2026)
    //       This is to keep the those endpoints from being disclosed in production.
    // post: api/login/Forgot?username=${encodeURIComponent(username)}
    public forgotPassword(username: string): Promise<void> {
        let url = `api/login/Forgot`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (username != null) {
            url += `${prefix}username=${encodeURIComponent(username)}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        return this.SendRequest<any, void>(null, 'post', url, true, false);
    }

    // post: api/login/ChangePassword
    public changePassword(dto: LoginDTO): Promise<LoginResponseDTO> {
        let url = `api/login/ChangePassword`;

        url = url.replace(/null|undefined/gi, '');
        return this.SendRequest<any, LoginResponseDTO>(dto, 'post', url, true, false);
    }

    // post: api/login/AboutToExpireResponse?change=${change}
    public aboutToExpireResponse(dto: LoginDTO, change: boolean): Promise<LoginResponseDTO> {
        let url = `api/login/AboutToExpireResponse`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (change != null) {
            url += `${prefix}change=${change}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        return this.SendRequest<any, LoginResponseDTO>(dto, 'post', url, true, false);
    }

    // post: api/login/VerifyNewMfaDevice
    public verifyNewMfaDevice(dto: LoginDTO): Promise<LoginResponseDTO> {
        let url = `api/login/VerifyNewMfaDevice`;

        url = url.replace(/null|undefined/gi, '');
        return this.SendRequest<any, LoginResponseDTO>(dto, 'post', url, true, false);
    }

    // post: api/login/MfaChallenge
    public mfaChallenge(dto: LoginDTO): Promise<LoginResponseDTO> {
        let url = `api/login/MfaChallenge`;

        url = url.replace(/null|undefined/gi, '');
        return this.SendRequest<any, LoginResponseDTO>(dto, 'post', url, true, false);
    }

    // post: api/login/SelectFacility?facilityId=${encodeURIComponent(facilityId)}
    public selectFacility(facilityId: string): Promise<GenericResponseDTO> {
        let url = `api/login/SelectFacility`;
        let prefix = url.indexOf('?') > 0 ? '&' : '?';
        if (facilityId != null) {
            url += `${prefix}facilityId=${encodeURIComponent(facilityId)}`;
            prefix = '&';
        }

        url = url.replace(/null|undefined/gi, '');
        return this.SendRequest<any, GenericResponseDTO>(null, 'post', url, true, false);
    }
}
var service = new LoginApiService();
export default service;
